import { GiPositionMarker } from "react-icons/gi";

function Marker() {
  return (
    <GiPositionMarker color="red" size="20" />
  );
}

export default Marker;
